<script setup lang="ts">
const { openInNewTab } = useDOM()
const { t } = useI18n()
const imgCloud = computed(
  () => `${import.meta.env.VITE_AWS_STORAGE_URL}/dashboard/upsell-banner-ressources/bg-img-banner.png`
)
const iconRocket = computed(
  () => `${import.meta.env.VITE_AWS_STORAGE_URL}/dashboard/upsell-banner-ressources/rocket.png`
)

const { getStoreSchedulingPlatformUrl, selectedStore } = useStore()

const bannerRedirection = () => {
  const url = `${getStoreSchedulingPlatformUrl(
    selectedStore.value
  )}?utm_source=pongo&utm_medium=dashboard&utm_campaign=dashboard&utm_content=demo`
  openInNewTab(url)
}
</script>
<template>
  <div
    class="relative flex flex-col items-center justify-between rounded-md bg-brand-gradient bg-cover bg-top-right p-6 text-white sm:flex-row"
  >
    <img class="absolute inset-0 h-full w-full object-cover" :src="imgCloud" />
    <div class="z-10 flex flex-col items-center sm:flex-row md:gap-5 lg:gap-10">
      <img class="mr-2 w-24" :src="iconRocket" />
      <div>
        <div class="flex flex-col items-center text-lg font-semibold md:flex-row">
          {{ t('pages.dashboard.dashboardPage.banner.title') }}
          <img class="mt-2 w-16 md:ml-2" src="/images/dashboard/logo.png" />
        </div>
        <p class="mt-2 max-w-2xl text-center md:mt-0 md:text-left 2xl:max-w-4xl">
          {{ t('pages.dashboard.dashboardPage.banner.description') }}
        </p>
      </div>
    </div>
    <Button variant="secondary" class="z-10 mt-4 w-full md:ml-1 md:mt-2 md:w-auto" @click="bannerRedirection">
      {{ t('pages.dashboard.dashboardPage.banner.button') }}
    </Button>
  </div>
</template>
